/**
 * assets/pdp-v3.js
 * Handles interactivity for the Product Template v3 (SNS bundle builder).
 */
(function () {
  'use strict';

  function formatMoney(cents, moneyFormat) {
    var amount = (cents / 100).toFixed(2);
    if (moneyFormat) return moneyFormat.replace('{{amount}}', amount).replace('{{amount_no_decimals}}', Math.round(cents / 100));
    return '\u00A3' + amount;
  }

  function initPdpV3(infoEl) {
    var moneyFormat = infoEl.dataset.moneyFormat || null;
    var currentType = infoEl.dataset.initialType || 'onetime';

    // ── Purchase type toggle ──────────────────────────────────────────────────
    var typeBtns = infoEl.querySelectorAll('.pdp-v3__type-btn');
    var benefitsPanel = infoEl.querySelector('.pdp-v3__sns-benefits');
    var subBtn = infoEl.querySelector('.pdp-v3__type-btn[data-type="subscription"]');
    var otpBtn = infoEl.querySelector('.pdp-v3__type-btn[data-type="onetime"]');
    var unitPriceEl = infoEl.querySelector('.pdp-v3__unit-price');

    function setType(type) {
      currentType = type;

      typeBtns.forEach(function (btn) {
        var active = btn.dataset.type === type;
        btn.style.backgroundColor = active ? '#e5d8c8' : 'white';
        var filledRadio = btn.querySelector('.pdp-v3__type-radio-filled');
        var emptyRadio = btn.querySelector('.pdp-v3__type-radio-empty');
        if (filledRadio) filledRadio.classList.toggle('hidden', !active);
        if (emptyRadio) emptyRadio.classList.toggle('hidden', active);
      });

      // Update unit price bullet
      if (unitPriceEl) {
        var isSub = type === 'subscription';
        var snsPrice = unitPriceEl.dataset.snsPrice;
        var otpPrice = unitPriceEl.dataset.otpPrice;
        unitPriceEl.textContent = (isSub && snsPrice) ? snsPrice : otpPrice;
      }

      // Show/hide benefits panel and update tab rounding + borders
      if (benefitsPanel) {
        var showBenefits = type === 'subscription';
        benefitsPanel.classList.toggle('hidden', !showBenefits);

        // Sub (left) tab: no bottom border or bottom-left radius when benefits shown
        if (subBtn) {
          subBtn.style.borderBottomWidth = showBenefits ? '0' : '';
          subBtn.style.borderRadius = showBenefits ? '6px 0 0 0' : '6px 0 0 6px';
        }
        if (otpBtn) {
          otpBtn.style.borderRadius = showBenefits ? '0 6px 0 0' : '0 6px 6px 0';
        }
      }

      updateCta();
    }

    typeBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        setType(btn.dataset.type);
      });
    });

    // ── Stepper ───────────────────────────────────────────────────────────────
    var rows = infoEl.querySelectorAll('.pdp-v3__flavour-row');

    function updateRowStyle(row) {
      var qtyEl = row.querySelector('.pdp-v3__row-qty');
      if (!qtyEl) return;
      var minusBtn = row.querySelector('.pdp-v3__row-minus');
      var plusBtn = row.querySelector('.pdp-v3__row-plus');
      var qty = parseInt(qtyEl.textContent, 10) || 0;
      var active = qty > 0;

      if (row.dataset.isCurrent === 'true') {
        row.style.backgroundColor = 'rgba(222,206,186,0.2)';
      }

      [minusBtn, plusBtn].forEach(function (btn) {
        if (!btn) return;
        btn.style.backgroundColor = active ? 'rgba(229,216,200,0.8)' : 'white';
        btn.style.borderColor = '#e5d8c8';
      });

      if (minusBtn) minusBtn.style.display = qty <= 0 ? 'none' : '';
    }

    rows.forEach(function (row) {
      var step = parseInt(row.dataset.step, 10) || 1;
      var qtyEl = row.querySelector('.pdp-v3__row-qty');
      var minusBtn = row.querySelector('.pdp-v3__row-minus');
      var plusBtn = row.querySelector('.pdp-v3__row-plus');

      if (!qtyEl || !plusBtn) return;

      plusBtn.addEventListener('click', function () {
        var qty = parseInt(qtyEl.textContent, 10) || 0;
        qtyEl.textContent = qty + step;
        updateRowStyle(row);
        updateTotal();
        updateCta();
      });

      if (minusBtn) {
        minusBtn.addEventListener('click', function () {
          var qty = parseInt(qtyEl.textContent, 10) || 0;
          if (qty <= 0) return;
          qtyEl.textContent = Math.max(0, qty - step);
          updateRowStyle(row);
          updateTotal();
          updateCta();
        });
      }
    });

    // ── Total badge ───────────────────────────────────────────────────────────
    var totalCountEl = infoEl.querySelector('.pdp-v3__total-count');
    var totalLabelEl = infoEl.querySelector('.pdp-v3__total-label');

    function updateTotal() {
      var total = 0;
      rows.forEach(function (row) {
        var qtyEl = row.querySelector('.pdp-v3__row-qty');
        total += parseInt(qtyEl ? qtyEl.textContent : 0, 10) || 0;
      });
      if (totalCountEl) totalCountEl.textContent = total;
      if (totalLabelEl) {
        totalLabelEl.textContent = total === 1
          ? (totalLabelEl.dataset.singular || totalLabelEl.dataset.plural)
          : totalLabelEl.dataset.plural;
      }
      return total;
    }

    // ── CTA prices ────────────────────────────────────────────────────────────
    var atcOtpPriceEl = infoEl.querySelector('.pdp-v3__atc-otp-price');
    var atcSnsPriceEl = infoEl.querySelector('.pdp-v3__atc-sns-price');
    var atcPriceEl = infoEl.querySelector('.pdp-v3__atc-price');
    var atcLabelEl = infoEl.querySelector('.pdp-v3__atc-label');
    var atcPipeEl = infoEl.querySelector('.pdp-v3__atc-pipe');

    function updateCta() {
      var otpTotal = 0;
      var snsTotal = 0;
      var rrpTotal = 0;
      var totalQty = 0;

      rows.forEach(function (row) {
        var qty = parseInt(row.querySelector('.pdp-v3__row-qty') ? row.querySelector('.pdp-v3__row-qty').textContent : 0, 10) || 0;
        var step = parseInt(row.dataset.step, 10) || 1;
        var packs = qty / step;
        var price = parseInt(row.dataset.price, 10) || 0;
        var snsPrice = parseInt(row.dataset.snsPrice, 10) || 0;
        var rrp = parseInt(row.dataset.rrp, 10) || 0;
        otpTotal += packs * price;
        snsTotal += packs * (snsPrice || price);
        rrpTotal += packs * rrp;
        totalQty += qty;
      });

      var isEmpty = totalQty === 0;
      if (atcBtn) atcBtn.style.opacity = isEmpty ? '0.4' : '1';
      if (atcPipeEl) atcPipeEl.style.display = isEmpty ? 'none' : '';
      if (isEmpty) {
        if (atcLabelEl) atcLabelEl.textContent = atcBtn && atcBtn.dataset.oos === 'true' ? 'Out of Stock' : 'Add an item to continue';
        if (atcOtpPriceEl) atcOtpPriceEl.style.display = 'none';
        if (atcSnsPriceEl) atcSnsPriceEl.style.display = 'none';
        if (atcPriceEl) atcPriceEl.style.display = 'none';
        return;
      }

      var isSub = currentType === 'subscription';
      var label = isSub ? 'SUBSCRIBE' : 'ADD TO CART';

      if (atcLabelEl) atcLabelEl.textContent = label;

      if (isSub && snsTotal > 0 && snsTotal !== otpTotal) {
        // Subscription: strikethrough OTP + SNS discounted price
        if (atcOtpPriceEl) { atcOtpPriceEl.textContent = formatMoney(otpTotal, moneyFormat); atcOtpPriceEl.style.display = ''; }
        if (atcSnsPriceEl) { atcSnsPriceEl.textContent = formatMoney(snsTotal, moneyFormat); atcSnsPriceEl.style.display = ''; }
        if (atcPriceEl) atcPriceEl.style.display = 'none';
      } else if (!isSub && rrpTotal > 0) {
        // OTP with RRP: strikethrough RRP + actual price
        if (atcOtpPriceEl) { atcOtpPriceEl.textContent = formatMoney(rrpTotal, moneyFormat); atcOtpPriceEl.style.display = ''; }
        if (atcSnsPriceEl) atcSnsPriceEl.style.display = 'none';
        if (atcPriceEl) { atcPriceEl.textContent = formatMoney(otpTotal, moneyFormat); atcPriceEl.style.display = ''; }
      } else {
        if (atcOtpPriceEl) atcOtpPriceEl.style.display = 'none';
        if (atcSnsPriceEl) atcSnsPriceEl.style.display = 'none';
        var displayPrice = isSub ? snsTotal : otpTotal;
        if (atcPriceEl) {
          atcPriceEl.textContent = displayPrice > 0 ? formatMoney(displayPrice, moneyFormat) : '';
          atcPriceEl.style.display = displayPrice > 0 ? '' : 'none';
        }
      }
    }


    // ── Add to cart ───────────────────────────────────────────────────────────
    var atcBtn = infoEl.querySelector('.pdp-v3__atc');
    if (atcBtn) {
      atcBtn.addEventListener('click', function () {
        // If a bundle builder page is configured and type is subscription, redirect there
        var bundleUrl = infoEl.dataset.bundleUrl;
        if (currentType === 'subscription' && bundleUrl) {
          var url = new URL(bundleUrl, window.location.origin);
          rows.forEach(function (row) {
            var qtyEl = row.querySelector('.pdp-v3__row-qty');
            var qty = parseInt(qtyEl ? qtyEl.textContent : 0, 10) || 0;
            if (qty > 0 && row.dataset.handle) url.searchParams.append('add', row.dataset.handle);
          });
          window.location.href = url.toString();
          return;
        }

        var items = [];
        rows.forEach(function (row) {
          var qtyEl = row.querySelector('.pdp-v3__row-qty');
          var qty = parseInt(qtyEl ? qtyEl.textContent : 0, 10) || 0;
          if (qty <= 0) return;
          var step = parseInt(row.dataset.step, 10) || 1;
          var variantId = parseInt(row.dataset.variantId, 10);
          var sellingPlan = row.dataset.sellingPlan;
          var item = { id: variantId, quantity: qty / step };
          if (currentType === 'subscription' && sellingPlan) {
            item.selling_plan = parseInt(sellingPlan, 10);
          }
          items.push(item);
        });

        if (items.length === 0) return;

        atcBtn.disabled = true;
        var originalLabel = atcLabelEl ? atcLabelEl.textContent : '';
        if (atcLabelEl) atcLabelEl.textContent = 'Adding...';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items: items })
        })
          .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
          .then(function (res) {
            if (!res.ok) {
              var msg = res.data.description || 'Something went wrong — please try again';
              if (atcLabelEl) atcLabelEl.textContent = msg;
              atcBtn.disabled = false;
              setTimeout(function () {
                if (atcLabelEl) atcLabelEl.textContent = originalLabel;
              }, 4000);
              return;
            }
            window.location.href = '/cart';
          })
          .catch(function (err) {
            console.error('[pdp-v3] Add to cart error:', err);
            if (atcLabelEl) atcLabelEl.textContent = 'Something went wrong — please try again';
            atcBtn.disabled = false;
            setTimeout(function () {
              if (atcLabelEl) atcLabelEl.textContent = originalLabel;
            }, 4000);
          });
      });
    }

    // ── Learn more modal ──────────────────────────────────────────────────────
    var learnMoreOverlay = infoEl.querySelector('.pdp-v3__learn-more-overlay');
    var learnMoreBody = learnMoreOverlay ? learnMoreOverlay.querySelector('.pdp-v3__learn-more-body') : null;
    var learnMoreClose = learnMoreOverlay ? learnMoreOverlay.querySelector('.pdp-v3__learn-more-close') : null;
    var learnMoreTriggerBtn = null;

    function closeLearnMore() {
      if (learnMoreOverlay) learnMoreOverlay.classList.add('hidden');
      document.body.style.overflow = '';
      if (learnMoreTriggerBtn) learnMoreTriggerBtn.focus();
      learnMoreTriggerBtn = null;
    }

    function trapFocus(e) {
      if (!learnMoreOverlay || learnMoreOverlay.classList.contains('hidden')) return;
      var focusable = learnMoreOverlay.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (e.key === 'Tab') {
        if (e.shiftKey) {
          if (document.activeElement === first) { e.preventDefault(); last.focus(); }
        } else {
          if (document.activeElement === last) { e.preventDefault(); first.focus(); }
        }
      }
    }

    infoEl.querySelectorAll('.pdp-v3__learn-more-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var productId = btn.dataset.productId;
        var content = infoEl.querySelector('.pdp-v3__learn-more-content[data-product-id="' + productId + '"]');
        if (!content || !learnMoreOverlay || !learnMoreBody) return;
        learnMoreTriggerBtn = btn;
        learnMoreBody.innerHTML = content.innerHTML;
        learnMoreOverlay.classList.remove('hidden');
        document.body.style.overflow = 'hidden';
        if (learnMoreClose) learnMoreClose.focus();
      });
    });

    if (learnMoreClose) learnMoreClose.addEventListener('click', closeLearnMore);
    if (learnMoreOverlay) {
      learnMoreOverlay.addEventListener('click', function (e) {
        if (e.target === learnMoreOverlay) closeLearnMore();
      });
    }

    // ── Reviews modal ─────────────────────────────────────────────────────────
    var reviewsOverlay = infoEl.querySelector('.pdp-v3__reviews-overlay');
    var reviewsBody    = reviewsOverlay ? reviewsOverlay.querySelector('.pdp-v3__reviews-body') : null;
    var reviewsClose   = reviewsOverlay ? reviewsOverlay.querySelector('.pdp-v3__reviews-close') : null;

    function closeReviews() {
      if (reviewsOverlay) reviewsOverlay.classList.add('hidden');
      document.body.style.overflow = '';
    }


    if (reviewsClose) reviewsClose.addEventListener('click', closeReviews);
    if (reviewsOverlay) {
      reviewsOverlay.addEventListener('click', function (e) {
        if (e.target === reviewsOverlay) closeReviews();
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closeLearnMore(); closeReviews(); }
      trapFocus(e);
    });

    // ── Initialise states ─────────────────────────────────────────────────────
    rows.forEach(updateRowStyle);
    updateTotal();
    updateCta();

    // ── Gallery (Swiper) ──────────────────────────────────────────────────────
    var section = infoEl.closest('.product-template');
    initGallery(section);
  }

  function initGallery(section) {
    if (!section) return;

    var mainEl   = section.querySelector('.pdp-gallery-swiper--desktop');
    var thumbsEl = section.querySelector('.pdp-gallery-swiper--thumbs');
    var prevBtn  = section.querySelector('.pdp-swiper__prev');
    var nextBtn  = section.querySelector('.pdp-swiper__next');

    // Guard: skip if app.js already initialised Swiper on this element
    if (mainEl && mainEl.swiper) return;
    if (mainEl && mainEl.dataset.v3GalleryInit) return;
    if (mainEl) mainEl.dataset.v3GalleryInit = '1';

    var slides = mainEl ? Array.from(mainEl.querySelectorAll('.swiper-slide')) : [];
    var thumbs = thumbsEl ? Array.from(thumbsEl.querySelectorAll('.swiper-slide')) : [];
    var current = 0;

    if (slides.length === 0) return;

    function goTo(index) {
      if (index < 0) index = slides.length - 1;
      if (index >= slides.length) index = 0;
      current = index;

      // Slide the main wrapper — measure slide width fresh to avoid drift
      var wrapper = mainEl.querySelector('.swiper-wrapper');
      if (wrapper) {
        var slideWidth = slides[0] ? slides[0].getBoundingClientRect().width : mainEl.offsetWidth;
        wrapper.style.transform = 'translateX(-' + (current * slideWidth) + 'px)';
      }

      // Update thumb active state
      thumbs.forEach(function (thumb, i) {
        thumb.style.opacity = i === current ? '1' : '0.5';
        thumb.style.outline = 'none';
      });
    }

    // Make wrapper slide-able
    var wrapper = mainEl.querySelector('.swiper-wrapper');
    if (wrapper) {
      var slideW = mainEl.offsetWidth;
      wrapper.style.display = 'flex';
      wrapper.style.transition = 'transform 0.3s ease';
      wrapper.style.willChange = 'transform';
      slides.forEach(function (slide) {
        slide.style.width = slideW + 'px';
        slide.style.minWidth = slideW + 'px';
        slide.style.flexShrink = '0';
      });
      window.addEventListener('resize', function () {
        var w = mainEl.offsetWidth;
        slides.forEach(function (slide) {
          slide.style.width = w + 'px';
          slide.style.minWidth = w + 'px';
        });
        goTo(current);
      });
    }

    // Nav buttons
    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); });

    // Thumb clicks
    thumbs.forEach(function (thumb, i) {
      thumb.style.cursor = 'pointer';
      thumb.addEventListener('click', function () { goTo(i); });
    });

    // Touch/swipe on main
    var touchStartX = null;
    mainEl.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
    }, { passive: true });
    mainEl.addEventListener('touchend', function (e) {
      if (touchStartX === null) return;
      var diff = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) goTo(current + (diff > 0 ? 1 : -1));
      touchStartX = null;
    }, { passive: true });

    goTo(0);
  }

  // ── Reviews modal open (document-level capture — works on PDPs and CDPs) ───
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.reviews-modal-trigger');
    if (!trigger) return;
    e.stopPropagation();
    e.preventDefault();
    var overlay = document.querySelector('.pdp-v3__reviews-overlay');
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.className = 'pdp-v3__reviews-overlay hidden';
      overlay.innerHTML = '<div class="pdp-v3__reviews-box"><button class="pdp-v3__reviews-close" type="button" aria-label="Close reviews" style="position:absolute;top:12px;right:12px;display:flex;width:32px;height:32px;background:none;border:none;border-radius:50%;cursor:pointer;align-items:center;justify-content:center;padding:0;"><svg width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M1 1L17 17M17 1L1 17" stroke="#2c2c2c" stroke-width="2" stroke-linecap="round"/></svg></button><div class="pdp-v3__reviews-body"></div></div>';
      document.body.appendChild(overlay);
      overlay.querySelector('.pdp-v3__reviews-close').addEventListener('click', function () { overlay.classList.add('hidden'); document.body.style.overflow = ''; });
      overlay.addEventListener('click', function (e) { if (e.target === overlay) { overlay.classList.add('hidden'); document.body.style.overflow = ''; } });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { overlay.classList.add('hidden'); document.body.style.overflow = ''; } });
    }
    var body = overlay.querySelector('.pdp-v3__reviews-body');
    if (!body) return;
    overlay.classList.remove('hidden');
    document.body.style.overflow = 'hidden';
    if (body.dataset.initialized) return;
    body.dataset.initialized = '1';
    var sku = trigger.dataset.sku || '';
    function initReviewsWidget() {
      var el = document.createElement('div');
      el.id = 'pdp-reviews-widget-' + Date.now();
      body.appendChild(el);
      new ReviewsWidget('#' + el.id, {
        store: 'take-stock',
        widget: 'polaris',
        options: {
          types: 'product_review',
          lang: 'en',
          per_page: 10,
          product_review: { sku: sku },
          header: {
            enable_summary: true,
            enable_ratings: true,
            enable_attributes: false,
            enable_image_gallery: false,
            enable_percent_recommended: false,
            enable_write_review: false,
            enable_ask_question: false,
            enable_sub_header: true,
            rating_decimal_places: 2,
            use_write_review_button: false
          },
          filtering: {
            enable: true,
            enable_text_search: false,
            enable_sorting: true,
            enable_overall_rating_filter: true,
            enable_ratings_filters: false
          },
          reviews: {
            default_sort: 'highest_rating',
            enable_avatar: false,
            enable_reviewer_name: true,
            enable_reviewer_address: false,
            enable_verified_badge: true,
            enable_subscriber_badge: false,
            enable_images: true,
            enable_share: false,
            enable_helpful_vote: true,
            enable_helpful_display: true,
            enable_date: true
          }
        },
        styles: {
          '--base-font-size': '16px',
          '--common-star-color': '#FF9600',
          '--common-star-disabled-color': 'rgba(0,0,0,0.25)',
          '--medium-star-size': '22px',
          '--small-star-size': '19px',
          '--heading-text-color': '#2c2c2c',
          '--heading-text-font-weight': '700',
          '--heading-text-font-family': 'inherit',
          '--body-text-color': '#2c2c2c',
          '--body-text-font-family': 'inherit',
          '--badge-text-color': '#2c2c2c',
          '--badge-icon-color': '#2c2c2c',
          '--pagination-tab-text-color': '#2c2c2c',
          '--pagination-tab-active-text-color': '#2c2c2c',
          '--pagination-tab-active-border-color': '#2c2c2c',
          '--common-border-color': '#DDCEB8',
          '--common-border-width': '1px',
          '--inputfield-text-font-family': 'inherit',
          '--inputfield-border-color': 'rgba(0,0,0,0.2)'
        }
      });
    }
    if (window.ReviewsWidget) { initReviewsWidget(); return; }
    var existing = document.querySelector('script[src*="polaris/build.js"]');
    if (existing) {
      var poll = setInterval(function () { if (window.ReviewsWidget) { clearInterval(poll); initReviewsWidget(); } }, 50);
      return;
    }
    var s = document.createElement('script');
    s.src = 'https://widget.reviews.co.uk/polaris/build.js';
    s.onload = initReviewsWidget;
    document.head.appendChild(s);
  }, true);

  // ── Accordions (delegated — works in modal + dynamically injected content) ─
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.pdp-v3__accordion-trigger');
    if (!trigger) return;
    var body = trigger.nextElementSibling;
    if (!body) return;
    var isOpen = !body.classList.contains('hidden');
    body.classList.toggle('hidden', isOpen);
    trigger.setAttribute('aria-expanded', String(!isOpen));
    var arrow = trigger.querySelector('.pdp-v3__accordion-arrow');
    if (arrow) arrow.style.transform = isOpen ? '' : 'rotate(180deg)';
  });

  // ── Boot ──────────────────────────────────────────────────────────────────
  function init() {
    document.querySelectorAll('.product-template-v3__info').forEach(initPdpV3);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
